import { Button, Card, Checkbox, Col, Flex, Form, Input, List, Modal, Radio, Row, Table } from "antd";
import { useState,useEffect, useRef } from "react";
import LoadingOverlay from 'react-loading-overlay-ts';
import { InvitedNewParticipant,InvitedParticipant, ProjectInfoInterface } from "../../model/IprojectInfo";
import moment from "moment";
import { ResearcherInterface } from "../../model/IResearcher";
import {
    UploadOutlined
  } from '@ant-design/icons';
import { FlieListInterface } from "../../model/IFileList";
import CkEditor from "../../ckeditor/ckEditor";
import { Editor } from "ckeditor5";
import axios from "axios";
import TextArea from "antd/lib/input/TextArea";

export function CommitteeData(){

    const [Reviewform] = Form.useForm()
    const Review_result = Form.useWatch('review_result', Reviewform);


    const {ROCKEditors,CKEditors,getHTML} = CkEditor();

    const [isActive,setisActive] = useState(false);
    const [ConfirmationMod,setComfirmationMod] = useState(false);

    const [AllData,setAlldata] = useState<ProjectInfoInterface>();
    const [HeadResData,setHeadResdata] = useState<ResearcherInterface>();
    const [researcher_position, setresearcher_position] = useState('');
    const [JoinedData,set๋JoinedData] = useState<ResearcherInterface[]>([]);

    const [ShowFile,setShowFile] = useState(false);
    const [ShowMultipleFiles,setShowMultipleFiles] = useState(false);
    const [ShowImage,setShowImage] = useState(false);
    const [SubFileList,setSubFileList] = useState<FlieListInterface[]>([])
    const [submit,setSubmit] = useState(false);
    const [FileType,setFileType] = useState<string | null>(null);
    const [Topic,setTopic] = useState('')


    const [AllFileList,setAllFileList] = useState<FlieListInterface[]>([])
    const [FileAttachment, setFileAttachment] = useState([
        {   
            id:1,
            AttachmentType:'เค้าโครงวิจัย 3 บท',
            Status:'ยังไม่แนบ'
        },{
            id:2,
            AttachmentType:'เครื่องมือหรือแบบสอบถาม (ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:3,
            AttachmentType:'หนังสือรับรองการประเมินคุณภาพเครื่องมือวิจัย(ถ้ามี)',
            Status:'ยังไม่แนบ'
        },
        {
            id:4,
            AttachmentType:'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครทั่วไป (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:5,
            AttachmentType:'เอกสารแสดงความยินยอมเข้าร่วมโครงการวิจัยสำหรับอาสาสมัครเด็ก 7-18 ปี (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:6,
            AttachmentType:'เอกสารแสดงความยินยอมสำหรับอาสาสมัครกลุ่มเปราะบาง (ถ้าเกี่ยวข้อง)',
            Status:'ยังไม่แนบ'
        },
        {
            id:7,
            AttachmentType:'เอกสารรับรองการสอบผ่านโครงร่างวิทยานิพนธ์ ภาคนิพนธ์ หรือการศึกษาค้นคว้าอิสระ',
            Status:'ยังไม่แนบ'
        },
        {
            id:8,
            AttachmentType:'เอกสารสัญญาการให้ทุนวิจัย',
            Status:'ยังไม่แนบ'
        },
        {
            id:9,
            AttachmentType:'หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์',
            Status:'ยังไม่แนบ'
        },
        {
            id:10,
            AttachmentType:'หลักฐานการชำระเงินค่าธรรมเนียมในการพิจารณาจริยธรรมการวิจัยในมนุษย์',
            Status:'ยังไม่แนบ'
        },
        {
            id:11,
            AttachmentType:'หลักฐานการรับรองคำพิจารณาจริยธรรมจากที่ปรึกษา (สำหรับนักศึกษา)',
            Status:'ยังไม่แนบ'
          },
        ]);

    const [limit,setLimit] = useState(0);

    const participants = [
        {
          order_id: 1,
          researcher_THname: HeadResData?.researcher_THname || 'error',
          join_per: HeadResData?.join_per || 0,
        },
        ...(JoinedData.length>0
            ? JoinedData.map((r, idx) => ({
                order_id: idx + 2, // head is order 1
                researcher_THname: r.researcher_THname,
                join_per: r.join_per || 0,
              }))
            : []),
      ];

      const [invitedParticipant, setInvitedParticipant] = useState<InvitedParticipant>({
        healthy: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        patient: {
          count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
        other: {
        othertype:'',
        count: null,
          note:'',
          age:'',
          age_year: null,
          age_month: null,
          gender: [],
        },
      });

      const ReviewAndRecommendation = [
        {
            Topic:'บทนำ',
            Reccommendation:''
        },{
            Topic:'วัตถุประสงค์',
            Reccommendation:''
        },{
            Topic:'วิธีดำเนินการวิจัย',
            Reccommendation:''
        },{
            Topic:'การสร้างเครื่องมือ',
            Reccommendation:''
        },{
            Topic:'การเก็บรวบรวมข้อมูล',
            Reccommendation:''
        },{
            Topic:'ภาพรวมของเครื่องมือ',
            Reccommendation:''
        },{
            Topic:'การชี้แจงอาสาสมัคร',
            Reccommendation:''
        },{
            Topic:'อื่นๆ (ถ้ามี)',
            Review:''
        },
    ]

    const ParticipantAmountRef = useRef<Editor | null>(null);
    const ParticipantProcedureRef = useRef<Editor | null>(null);
    const ParticipantGroupByRef = useRef<Editor | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);

    async function viewFile(Topic:any){
        setTopic(Topic)
        if (Topic === "เครื่องมือหรือแบบสอบถาม (ถ้ามี)"
        ||Topic === "เอกสารสัญญาการให้ทุนวิจัย"
          ) {
              setisActive(true);
              const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);
              console.log(filtered);
              setSubFileList(filtered);
              setShowMultipleFiles(true);
              setisActive(false);
          }else if(Topic=='หลักฐานการผ่านการอบรมจริยธรรมการวิจัยในมนุษย์'){
          
          const filtered = AllFileList.filter(item => item.Topic.trim() === Topic);
          console.log(filtered[0].FileType)
          if(filtered[0].FileType=='image/jpeg'||filtered[0].FileType=='image/png'){
              setPreviewUrl(`${process.env.REACT_APP_BASE}/getImage/${filtered[0].FileID}`)
              setShowImage(true);
          }else{
              const data = {
                  topic:Topic
              }
  
              await axios.post(
                  `${process.env.REACT_APP_BASE}/GetFile/${sessionStorage.getItem('Order_ID')}`,
                  data,
                  { responseType: 'blob' }
                  ).then(response => {
                  if (response.status === 200) {
                      
                      const blob = response.data; // Axios already gives you a Blob
                      const blobUrl = URL.createObjectURL(blob);
                  
                      setPreviewUrl(blobUrl);    // For <iframe> src
                      setShowFile(true);         // Show modal/dialog/preview
                      setisActive(false);        // Stop loading spinner, etc.
                  }
                  }).catch(err => {
                  console.error("Error while fetching file:", err);
                  setisActive(false);
                  });
          }
          }else{
              setisActive(true)
              const data = {
                  topic:Topic
              }
              
              await axios.post(
                  `${process.env.REACT_APP_BASE}/GetFile/${sessionStorage.getItem('Order_ID')}`,
                  data,
                  { responseType: 'blob' }
              ).then(response => {
                  if (response.status === 200) {
                      
                  const blob = response.data; // Axios already gives you a Blob
                  const blobUrl = URL.createObjectURL(blob);
              
                  setPreviewUrl(blobUrl);    // For <iframe> src
                  setShowFile(true);         // Show modal/dialog/preview
                  setisActive(false);        // Stop loading spinner, etc.
                  }
              }).catch(err => {
                  console.error("Error while fetching file:", err);
                  setisActive(false);
              });
              
          }
    }

    async function ViewTool(id:any){
        const data = {
            topic:Topic,
        }
        await axios.post(
            `${process.env.REACT_APP_BASE}/GetFileForMultiplePDFAccept/${sessionStorage.getItem('Order_ID')}/${id}`,
            data,
            { responseType: 'blob' }
          ).then(response =>{
            if (response.status === 200) {
                setFileType(response.headers['content-type'])
    
                const blob = response.data; 
                const blobUrl = URL.createObjectURL(blob);
    
                setPreviewUrl(blobUrl); 
            }
          }).catch(err => {
            console.error("Error while fetching file:", err);
            setisActive(false);
          });


         
       
        }

        async function getData(){
            await axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfo/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('head_ID')}`).then(async response=>{
                if(response.status=200)
                    {
                        const tmpdata = response.data.data
                        setAlldata(tmpdata)

                       
                        const FaciData = sessionStorage.getItem('POS_ID');
      
                        setresearcher_position(tmpdata.posname)
            
                      //  
                        if(tmpdata.InvitedParticipant!=null&&tmpdata.InvitedParticipant!=''){
                            const data = JSON.parse(tmpdata.InvitedParticipant);
                            const invitedTypes: string[] = [];
                            if (data?.patient) invitedTypes.push('ผู้ป่วย');
                            if (data?.healthy) invitedTypes.push('ผู้มีสุขภาพดี');
                            if (data?.other) invitedTypes.push('อื่น ๆ');
      
                            setInvitedParticipant(data)
                        }
                        const head = response.data.Head
                        setHeadResdata({
                            ...head,
                            join_per:head.joinper
                        })
                        const Joined = response.data.Joined
                        set๋JoinedData(
                            Joined.map((item: { joinper: any; }) => ({
                              ...item,
                              join_per: item.joinper,
                            }))
                          )
      
                        if(tmpdata?.review_type){
                          if(tmpdata?.review_type=="การพิจารณาแบบยกเว้น (Exemption)"||
                              tmpdata?.review_type=="การพิจารณาแบบเร่งรัด (Expedited Review)"){
                              setLimit(2);
                          }else if(tmpdata?.review_type=='การพิจารณาแบบยกเว้น (Exemption)'){
                              setLimit(3)
                          }}

                          if(response.data.data.project_status=='รอพิจารณาผลการแก้ไขจากกรรมการ'||
                            response.data.data.project_status=='รอการพิจารณาจากกรรมการ'
                            ){  
                                await axios.get(`${process.env.REACT_APP_BASE}/getFullProjectInfo/${sessionStorage.getItem('Order_ID')}/${sessionStorage.getItem('head_ID')}`).then(resp=>{
                                    if(resp.status==200){
                                        
                                    }
                                })

                        }
                        
                          
                        
                    }
      
            })
           
            await axios
            .get(`${process.env.REACT_APP_BASE}/getFileList/${sessionStorage.getItem('Order_ID')}`)
            .then((res) => {
              if (res.status === 200 && res.data) {
                const uploadedFiles = res.data; // Array of { Topic: string }
          
                const updatedList = FileAttachment.map((item) => {
                  const isUploaded = uploadedFiles.some(
                    (file: { Topic: string }) => file.Topic === item.AttachmentType
                  );
                  return {
                    ...item,
                    Status: isUploaded ? 'แนบแล้ว' : 'ยังไม่แนบ',
                  };
                });
          
                setAllFileList(uploadedFiles);
                setFileAttachment(updatedList);
              }
            });
        }

          useEffect(() => {
            getData();
          }, []);
          
    return(
    <>
        <LoadingOverlay
            active={isActive}
            spinner
            text='กำลังโหลดข้อมูล'
        >
            <div id="part1-1"/>
            <h1>ข้อมูลโครงการ</h1>
            <hr/>
            <h2>ส่วนที่ 1 คำขอรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์ </h2>
            <Card>
            <h2>1.1 ข้อมูลเบื้องต้น</h2>
            <hr/>
            <Row>
                <Col span={12}>
                <p>
                    <span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย (ภาษาไทย) :</span> {AllData?.project_nameTH || <span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}
                </p>
                    
                </Col>
                <Col span={12}>
                    <p><span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย (ภาษาอังกฤษ) :</span> {AllData?.project_nameEN||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
                </Col>
            </Row>
            <p> <span style={{ fontWeight: 'bold' }}>ชื่อหัวหน้าโครงการวิจัย :</span> {HeadResData?.researcher_THname||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}({HeadResData?.researcher_ENname||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>})</p>
            <p> <span style={{ fontWeight: 'bold' }}>ตำแหน่งหัวหน้าโครงการวิจัย: </span>{researcher_position||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
            <p> <span style={{ fontWeight: 'bold' }}>สังกัดหัวหน้าโครงการวิจัย : </span>{HeadResData?.researcher_facility||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
            <p> <span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่อหัวหน้าโครงการวิจัย :</span>  {HeadResData?.researcher_phone||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>} </p>
            <p> <span style={{ fontWeight: 'bold' }}>Email หัวหน้าโครงการวิจัย :</span>  {HeadResData?.researcher_email||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
            <br/>
            {JoinedData.map((item, idx) => (
                <>
                <Card key={idx}>
                    <p><span style={{ fontWeight: 'bold' }}>ชื่อผู้ร่วมวิจัย :</span> {item?.researcher_THname} ({item?.researcher_ENname})</p>
                    {/* <p><span style={{ fontWeight: 'bold' }}>ตำแหน่งผู้ร่วมวิจัย :</span>  {item?.posname} </p> */}
                    <p><span style={{ fontWeight: 'bold' }}>สังกัดผู้ร่วมวิจัย</span> {item?.researcher_facility}</p>
                    <p><span style={{ fontWeight: 'bold' }}>สัดส่วนภาระงานร้อยละ</span> {item?.join_per}</p>
                    <p><span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่อผู้ร่วมวิจัย</span> {item?.researcher_phone}</p>
                    <p><span style={{ fontWeight: 'bold' }}>Emailผู้ร่วมวิจัย</span> {item?.researcher_email}</p>
                </Card>
                <br/></>
            ))}
            <p style={{ fontWeight: 'bold' }}>สัดส่วนภาระงาน (กรณีที่มีการตีพิมพ์ในวารสาร)</p>
            {AllData?.IsJoinPer&&<Table columns={[
                {
                    title:'ลำดับ',
                    width:'5vw',
                    key:'order_id',
                    dataIndex:'order_id'
                },
                {
                    title:'ชื่อผู้มีส่วนร่วม',
                    key:'researcher_THname',
                    dataIndex:'researcher_THname'
                },
                {
                    title: 'สัดส่วนภาระงานร้อยละ',
                    key: 'join_per',
                    dataIndex: 'join_per',
                    width:'10vw',
                
                },
                ]}
                dataSource={participants}
                />||<p style={{marginLeft:20}}>ไม่สามารถจัดแบ่งได้เพราะเป็นการวิจัยแบบพหุสถาบัน/หลายประเทศ</p>
                }
                {(HeadResData?.posname!='บุคลากร'&&HeadResData?.posname!='อาจารย์')&&<><p><span style={{ fontWeight: 'bold' }}>ชื่ออาจารย์ที่ปรึกษา :</span> {AllData?.advice_Name||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
                <p><span style={{ fontWeight: 'bold' }}>สังกัดอาจารย์ที่ปรึกษา :</span> {AllData?.advice_fac||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
                <p><span style={{ fontWeight: 'bold' }}>เบอร์โทรศัพท์ติดต่ออาจารย์ที่ปรึกษา :</span> {AllData?.advice_PhoneNum||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
                <p><span style={{ fontWeight: 'bold' }}>Emailอาจารย์ที่ปรึกษา :</span> {AllData?.advice_Email||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p></>}

                <br/>HeadResData
                {(HeadResData?.posname!='บุคลากร'&&HeadResData?.posname!='อาจารย์')&&<>{AllData?.IsAcademicResearch=='ใช่'&&<p>โครงการนี้เป็นโครงการวิจัยเพื่อการศึกษา</p>
                ||AllData?.IsAcademicResearch=='ไม่ใช่'&&<p>โครงการนี้ไม่เป็นโครงการวิจัยเพื่อการศึกษา</p>
                ||<p>โครงการนี้ยังไม่ระบุว่าเป็นโครงการวิจัยเพื่อการศึกษาหรือไม่</p>}</>}
                <p><span style={{ fontWeight: 'bold' }}>โครงการนี้เป็นโครงการวิจัยประเภท :</span> {AllData?.project_type||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
                <p><span style={{ fontWeight: 'bold' }}>ผู้วิจัยมีโครงร่างงานวิจัย และแบบสอบถาม หรือเครื่องมือวิจัย เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์หริอไม่</span></p>
                {AllData?.IsQuestionair=='ไม่มี'&&
                    <p style={{marginLeft:20}}>{AllData?.IsQuestionair} เพราะ {AllData?.IsQuestionairReason
                ||<p>ยังไม่กรอก</p>}</p>||
                AllData?.IsQuestionair=='มี'||
                <p style={{marginLeft:20}}>ยังไม่กรอกข้อมูลแล้ว</p>
                }

                <br/>
                <h3>ระยะเวลา</h3>
                <Card>
                    <p>ระยะเวลาที่ดำเนินโครงการวิจัย {AllData?.ResearchPeriod_year||0} ปี {AllData?.ResearchPeriod_month||0} เดือน</p>
                    <p>
                        เริ่มตั้งแต่เดือน {
                            moment(AllData?.ResearchStartingDate).isValid()
                            ? moment(AllData?.ResearchStartingDate)
                                .add(543, 'year')
                                .format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        } จนถึงเดือน {
                            moment(AllData?.ResearchEndingDate).isValid()
                            ? moment(AllData?.ResearchEndingDate)
                                .add(543, 'year')
                                .format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        }
                        </p>
                    <p>ระยะเวลาที่ดำเนินการเก็บข้อมูล {AllData?.InfoGatheringPeriod_year||0} ปี {AllData?.InfoGatheringPeriod_year||0} เดือน</p>
                    <p>เริ่มตั้งแต่เดือน {moment(AllData?.InfoGatheringStartingDate).isValid()
                            ? moment(AllData?.InfoGatheringStartingDate).add(543, 'year').format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        } จนถึงเดือน {moment(AllData?.InfoGatheringEndingDate).isValid()
                            ? moment(AllData?.InfoGatheringEndingDate).add(543, 'year').format('MMMM YYYY')
                            : <span style={{ color: 'red' }}>ยังไม่กรอก</span>
                        }</p>
                </Card>

                <br/>
                <h3>งบประมาณ</h3>
                <p>งบประมาณโครงการวิจัย {AllData?.Projectfund||'0'} บาท</p>
                <p style={{fontWeight:'bold'}}>ค่าธรรมเนียมการพิจารณาจริยธรรมฯ</p>
                <p style={{marginLeft:20}}>{AllData?.EthicalApprovalFee||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
                <p style={{fontWeight:'bold'}}>แหล่งทุนสนับสนุน (Sponsor)</p>
                <p style={{marginLeft:20}}>{AllData?.Sponsor||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>


            </Card>
            <br/>
            <div id="part1-2"/>
            <Card>
                <h2>1.2 การพิจารณาจริยธรรม</h2>
                <Card>
                    <p>ผู้ที่จะได้รับเชิญเป็นผู้ร่วมโครงการวิจัย</p>
                    {invitedParticipant.healthy&&
                    <>
                        <Card>
                            <h3>ผู้มีสุขภาพดี</h3>
                            <p>จำนวน <span>{invitedParticipant.healthy.count}</span> คน</p>
                            <p>อายุ <span>{invitedParticipant.healthy.age_year}</span> ปี <span>{invitedParticipant.healthy.age_month}</span> เดือน</p>
                            <p>
                                เพศ {invitedParticipant.healthy.gender.join(', ')}
                            </p>
                        </Card>
                        <br/></>
                    }
                   {invitedParticipant.patient&&
                    <> <Card>
                            <h3>ผู้ป่วย</h3>
                            <p>จำนวน <span>{invitedParticipant.patient.count}</span> คน</p>
                            <p>อายุ <span>{invitedParticipant.patient.age_year}</span> ปี <span>{invitedParticipant.patient.age_month}</span> เดือน</p>
                            {/* <p>
                                เพศ {invitedParticipant.patient.gender.join(', ')}
                            </p> */}
                        </Card><br/>
                    </>
                    
                    }
                    
                    {invitedParticipant.other&&
                    <>
                        <Card>
                            <h3>อื่น ๆ</h3>
                            <p>จำนวน <span>{invitedParticipant.other.count}</span> คน</p>
                            <p>อายุ <span>{invitedParticipant.other.age_year}</span> ปี <span>{invitedParticipant.other.age_month}</span> เดือน</p>
                            <p>
                                เพศ {invitedParticipant.other.gender.join(', ')}
                            </p>
                        </Card>
                        <br/>
                    </>
                    }
                </Card>
                <br/>
                <p  style={{fontWeight:'bold'}}>การเจาะเลือดผู้ป่วย/อาสาสมัครหริอไม่ </p>
                <div style={{ marginLeft: 20 }}>
                    {AllData?.IsbloodDraw === 'มี' ? (
                        <p>มี มีรายละเอียดดังนี้</p>
                    ) : AllData?.IsbloodDraw ? (
                        <p>{AllData.IsbloodDraw}</p>
                    ) : (
                        <p style={{ color: 'red' }}>ยังไม่มีการลงข้อมูล</p>
                    )}
                    </div>
                {AllData?.IsbloodDraw=='มี'&&
                    <Card style={{marginLeft:20}}>
                        <p style={{fontWeight:'bold'}}>วัตถุประสงค์ของการเจาะเลือด</p>
                        <p
                            style={{ fontSize: '16px', marginLeft: 20 }}
                            dangerouslySetInnerHTML={{ 
                                __html: (AllData?.bloodDrawObjective || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
                            }}
                            />
                        <Row>
                            <Col span={12}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ fontWeight: 'bold', width: '5vw' }}>จำนวน</span>
                                <span>{AllData?.bloodDrawTimes}</span>
                                <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>ครั้ง</span>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ fontWeight: 'bold', width: '5vw' }}>ครั้งละ</span>
                                <span>{AllData?.bloodDrawAmount}</span>
                                <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>หยด/cc</span>
                                </div>
                            </Col>
                            </Row>

                            <Row>
                            <Col span={12}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ fontWeight: 'bold', width: '5vw' }}>ทั้งหมด</span>
                                <span>{AllData?.bloodDrawTotalTimes}</span>
                                <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>ครั้ง</span>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                <span style={{ fontWeight: 'bold', width: '5vw' }}>ต่อ</span>
                                <span>{AllData?.bloodDrawTotalMonth}</span>
                                <span style={{ fontWeight: 'bold', marginLeft: '3vw' }}>เดือน</span>
                                </div>
                            </Col>
                            </Row>

                    
                    </Card>}
                <p  style={{fontWeight:'bold'}}>หัตถการอื่นที่มีการรุกล้ำร่างกาย (Invasive Procedure)  </p>
                <div style={{ marginLeft: 20 }}>
                    {AllData?.IsInvasiveProcedure === 'มี' ? (
                        <p>มี มีรายละเอียดดังนี้</p>
                    ) : AllData?.IsInvasiveProcedure ? (
                        <p>{AllData.IsInvasiveProcedure}</p>
                    ) : (
                        <span style={{ color: 'red' }}>ยังไม่มีการลงข้อมูล</span>
                    )}
                </div>
                {AllData?.IsInvasiveProcedure == 'มี'&&
                <Card style={{marginLeft:20}}>
                    <p
                        style={{ fontSize: '16px', marginLeft: 20 }}
                        dangerouslySetInnerHTML={{ 
                            __html: (AllData?.InvasiveProcedureSummary || 'ยังไม่กรอกข้อมูล').replace(/\n/g, '<br/>') 
                        }}
                        />
                </Card>
                }
                <p  style={{fontWeight:'bold'}}>ความเสี่ยงและความไม่สะดวกสบายที่ผู้ป่วย/อาสาสมัคร จะได้รับจากการร่วมโครงการ</p>
                <p style={{marginLeft:20}}>{AllData?.RiskAndUncomfortableFactor||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                <p style={{fontWeight:'bold'}}>วิธีการหรือมาตรการที่จัดเตรียมเพื่อลดความเสี่ยงและความไม่สะดวกสบายที่ผู้ป่วย/อาสาสมัคร จะได้รับจากการร่วมโครงการ </p>
                <p style={{marginLeft:20}}>{AllData?.DefensiveMeasure||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                <p style={{fontWeight:'bold'}}>ถ้าหากเกิดอันตราย/ความเสียหายต่อผู้ถูกวิจัย ที่เป็นผลสืบเนื่องโดยตรงจากการวิจัยในผู้ป่วย ผู้เสนอโครงการและ/หรือผู้ให้ทุนสนับสนุน
                    การวิจัยจะให้การรักษาจนกลับคืนสภาพเดิม หรือชดเชยความเสียหายที่ไม่สามารถรักษาให้คืนสู่สภาพเดิมได้ ตลอดจน
                    ให้ความคุ้มครองด้านค่าใช้จ่ายแก่ผู้ถูกวิจัยอย่างไรบ้าง?</p>
                    <p style={{marginLeft:20}}>{AllData?.ExpenseCoverage||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                
                <p style={{fontWeight:'bold'}}>ผู้วิจัยและผู้ร่วมงานทุกคนในโครงการทราบโดยผ่านการอบรมจริยธรรมการวิจัยในมนุษย์และเข้าใจข้อตกลง หลักความเคารพ
                ในบุคคล หลักคุณประโยชน์ และหลักความยุติธรรม  หรือไม่ </p>
                <p style={{marginLeft:20}}>{AllData?.AcceptanceUnderstanding||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                <p style={{fontWeight:'bold'}}>โครงการวิจัยเกี่ยวข้องหรืออาจมีผลกระทบกระเทือนต่อศาสนา ความเชื่อ ขนบธรรมเนียมประเพณี หรือ วัฒนธรรมอันดีงามของประเทศไทย หรือของท้องถิ่นที่ทำการวิจัยอยู่หรือไม่</p>
                <p style={{marginLeft:20}}>{AllData?.IsCountryReligionRiskFactor||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                {AllData?.IsInvasiveProcedure&&<>
                    <p> {AllData?.CountryReligionRiskFactor}</p></>
                }
                <br/>
            </Card>
            <br/>
            <div id="part1-3"/>
            <Card>
                <h2>1.3 ยา</h2>

                <p style={{fontWeight:'bold'}}>โครงการวิจัยนี้มีการให้ยาและหรือสิ่งทดลอง (เช่น โปรแกรมการส่งเสริมสุขภาพ การนวด การใช้สมุนไพร เป็นต้น) แก่ผู้ป่วย/อาสาสมัครหรือไม่ </p>
                <p style={{marginLeft:20}}>{AllData?.IsMedicine||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                {AllData?.MedicineInfo&&<p>{AllData?.MedicineInfo}</p>}
                {AllData?.applicableFactor!='ไม่เกี่ยวข้องกับรายการข้างต้น'&&<p  style={{fontWeight:'bold'}}>โครงการวิจัยนี้เกี่ยวข้องกับ </p>}
                {AllData?.applicableFactor && AllData.applicableFactor !== "[]" ? (
                    <div style={{ marginLeft: 20 }}>
                        {JSON.parse(AllData.applicableFactor).map((item:any, idx:any) => (
                        <div key={idx}>- {item}</div>
                        ))}
                    </div>
                    ) : (
                    <p style={{ marginLeft: 20, color: 'red' }}>ไม่มีข้อมูล</p>
                    )}
                {AllData?.applicableFactorDesc&&<p style={{marginLeft:20}}>คำอธิบายประกอบ : {AllData?.applicableFactorDesc}</p>}
            </Card>
            <br/>
            <div id="part1-4"/>
            <Card>
                <h2>1.4 ทรัพย์สินทางปัญญาและอื่น ๆ</h2>

                <p style={{fontWeight:'bold'}}>ผลของการศึกษาวิจัย (Results) หรือวัสดุใด ๆ (Materials) ที่เก็บจากผู้ป่วยหรือที่จะเป็นผลลัพธ์จากการวิจัยอาจมีคุณค่าในแง่ทรัพย์สินทาง
                การค้าและ/หรือทรัพย์สินทางปัญญา (เช่น สิทธิบัตร) หรือไม่ อย่างไร </p>
                {AllData?.IsCommercialInterlectualProperty=='มี'&&<p style={{marginLeft:20}}>มี ดังนี้ {AllData?.ComIntDesc}</p>|| 
                <p style={{marginLeft:20}}>{AllData?.IsCommercialInterlectualProperty ||
                    <span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>}
                <p style={{fontWeight:'bold'}}>ผู้วิจัยจะส่งรายงานความก้าวหน้า (Progress Report) มายังคณะกรรมการเมื่อ</p>
                <p style={{marginLeft:20}}>{AllData?.ProgressReport||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>}</p>
                <p style={{fontWeight:'bold'}}>การเขียนทบทวนวรรณกรรม การนำผลงาน ข้อความ หรือความคิดเห็นของผู้อื่น มาดัดแปลง ตัดต่อ หรือแก้ไข (บางส่วนหรือทั้งหมด) ทำซ้ำกับบุคคลอื่น ไม่เกิน 30 %  </p>
                {AllData?.PlagiarismPer=='ไม่ใช่'&&<p  style={{marginLeft:20}}>{AllData?.PlagiarismPer} เพราะ {AllData?.PlagiarismDesc||<span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span>} </p>}
                {AllData?.PlagiarismPer=='ใช่'&&<p  style={{marginLeft:20}}>{AllData?.PlagiarismPer} </p>}
                {!AllData?.PlagiarismPer&&<p  style={{marginLeft:20}}><span style={{color:'red'}}>ยังไม่มีการลงข้อมูล</span> </p>}
            </Card>
            <br/>
            <div id="part1-5"/>
            <Card>
                <h2>1.5 คำรับรองจากผู้วิจัย</h2>
                {AllData?.Acceptance=='รับรอง'
                &&<>
                <p>ในการดำเนินการวิจัยในครั้งนี้ ข้าพเจ้าขอรับรองว่า</p>
                <p>1. ข้าพเจ้าได้ตรวจสอบความถูกต้องของข้อมูลทั้งหมดที่นำเสนอต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุลด้วยตนเอง</p>
                <p>2. ข้าพเจ้าจะไม่เริ่มดำเนินการวิจัยจนกว่าจะได้รับผลการพิจารณาจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล </p>
                <p>3. ข้าพเจ้าทราบว่าหากมีการแก้ไข/ปรับปรุงโครงการวิจัย นอกเหนือจากที่ยื่นขอรับการพิจารณาครั้งนี้ ข้าพเจ้าจะต้องรายงาน โดยใช้แบบฟอร์ม มว.จ.011 หรือ มว.จ.012 หรือ มว.จ.013 </p>
                <p>4. ข้าพเจ้าจะรายงานการแจ้งปิดโครงการวิจัยต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล โดยใช้แบบฟอร์ม มว.จ.016  เมื่อดำเนินโครงการวิจัยเสร็จสิ้นแล้ว</p></>
                ||AllData?.Acceptance=='ไม่รับรอง'
                &&<div><p  style={{color:'red'}}>ในการดำเนินการวิจัยในครั้งนี้ ข้าพเจ้าไม่รับรองว่า</p>
                <p>1. ข้าพเจ้าได้ตรวจสอบความถูกต้องของข้อมูลทั้งหมดที่นำเสนอต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุลด้วยตนเอง</p>
                <p>2. ข้าพเจ้าจะไม่เริ่มดำเนินการวิจัยจนกว่าจะได้รับผลการพิจารณาจากคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล </p>
                <p>3. ข้าพเจ้าทราบว่าหากมีการแก้ไข/ปรับปรุงโครงการวิจัย นอกเหนือจากที่ยื่นขอรับการพิจารณาครั้งนี้ ข้าพเจ้าจะต้องรายงาน โดยใช้แบบฟอร์ม มว.จ.011 หรือ มว.จ.012 หรือ มว.จ.013 </p>
                <p>4. ข้าพเจ้าจะรายงานการแจ้งปิดโครงการวิจัยต่อคณะกรรมการจริยธรรมการวิจัยในมนุษย์ มหาวิทยาลัยวงษ์ชวลิตกุล โดยใช้แบบฟอร์ม มว.จ.016  เมื่อดำเนินโครงการวิจัยเสร็จสิ้นแล้ว</p>
                </div>
                ||
                <><p>ยังไม่มีการยืนยันคำรับรองจากนักวิจัย</p></>}
                <p>ข้าพเจ้าต้องการหนังสือรับรองจากคณะกรรมการเป็นฉบับ</p>
                <Card>
                {AllData?.LangRecieve && AllData.LangRecieve !== "[]" ? (
                    JSON.parse(AllData.LangRecieve).join(", ")
                ) : (
                    <span style={{ color: 'red' }}>ยังไม่ระบุ</span>
                )}</Card>
            </Card>
            <br/><hr/>
            <div id="part2"/>
            <h2>ส่วนที่ 2 แบบเอกสารชี้แจงอาสาสมัคร เพื่อประกอบการพิจารณาจริยธรรมการวิจัยในมนุษย์</h2>
            <Card>
        <p> <span style={{ fontWeight: 'bold' }}>ชื่อโครงการวิจัย : </span>{AllData?.project_nameTH||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
        <Card>
        <p> <span style={{ fontWeight: 'bold' }}>ชื่อผู้วิจัย : </span>{HeadResData?.researcher_THname}</p>
        <p> <span style={{ fontWeight: 'bold' }}>ตำแหน่ง : </span>{HeadResData?.posname || <span style={{color:'red'}}>ไม่มีข้อมูล</span>}</p>
        <p> <span style={{ fontWeight: 'bold' }}>สถานที่ติดต่อผู้วิจัย (ที่ทำงาน) : </span>{HeadResData?.researcher_wp||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>สถานที่ติดต่อผู้วิจัย (บ้าน) : </span>{HeadResData?.researcher_address||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (ที่ทำงาน) : </span>{HeadResData?.researcher_wptel||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (บ้าน) : </span>{HeadResData?.researcher_tel||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>โทรศัพท์ (มือถือ) : </span>{HeadResData?.researcher_phone||'ยังไม่มีข้อมูล'}</p>
        <p> <span style={{ fontWeight: 'bold' }}>E-mail : </span>{HeadResData?.researcher_email||'ยังไม่มีข้อมูล'}</p>
        </Card>
       
        <hr/>
        <p> <span style={{ fontWeight: 'bold' }}>โครงการวิจัยนี้เกี่ยวข้องกับการวิจัย เรื่อง</span> </p>
        <p style={{marginLeft:20}}>{AllData?.relevantTopic}</p>
        <p> <span style={{ fontWeight: 'bold' }}>วัตถุประสงค์ของการวิจัย</span> </p>
        <p style={{marginLeft:20}}>{AllData?.Objective}</p>
        <Card>
            <p style={{fontWeight:'bold'}}><u>รายละเอียดของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย </u></p>
            <p style={{marginLeft:20}}>ลักษณะของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย  เกณฑ์การคัดเข้า และเกณฑ์การคัดออก: </p>
            <p style={{marginLeft:40}}>{AllData?.ParticipantCharacteristicAndCriterion||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

            <p style={{marginLeft:20}}>จำนวนของกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย: </p>
            <ROCKEditors
                myRef={ParticipantAmountRef}
                htmlBox={AllData?.ParticipantAmount ? AllData?.ParticipantAmount : "ยังไม่กรอกข้อมูล"}
                toolstate={false}
                />
            
            <p style={{marginLeft:20}}>วิธีการได้มาซึ่งกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย: </p>
            <p style={{marginLeft:40}}>{AllData?.ParticipantRecruit||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

            <p style={{marginLeft:20}}>เหตุผลที่ได้รับเชิญเข้าร่วมโครงการวิจัย: </p>
            <p style={{marginLeft:40}}>{AllData?.ParticipantReason||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

              </Card>
              <p style={{fontWeight:'bold'}}>กระบวนการการวิจัยที่กระทำต่อกลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย </p>
              <ROCKEditors
                      myRef={ParticipantGroupByRef}
                      htmlBox={AllData?.ParticipantGroupBy ? AllData?.ParticipantGroupBy : "ยังไม่กรอกข้อมูล"}
                      toolstate={false}
                      />


              <p style={{fontWeight:'bold'}}>กระบวนการให้ข้อมูลแก่กลุ่มประชากร หรือผู้มีส่วนร่วมในการวิจัย </p>
              <p style={{marginLeft:20}}>{AllData?.ParticipantAcknowledgementMethod||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

              <Card>
                  <p style={{fontWeight:'bold'}}>การใช้เวชระเบียน </p>
                  <p style={{marginLeft:20}}>การวิจัยที่ดูข้อมูลจากเวชระเบียนเท่านั้น ต้องได้รับการอนุมัติจากผู้มีอำนาจหน้าที่ เช่น ผู้อำนวยการโรงพยาบาล </p>
                  <p style={{marginLeft:40}}>{AllData?.MedicalRecordInfoAllowedByHead||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
                  <p style={{marginLeft:20}}>การวิจัยที่มีการกระทำต่อผู้ป่วยและใช้เวชระเบียนต้องได้รับการอนุมัติจากผู้มีอำนาจหน้าที่ เช่น ผู้อำนวยการโรงพยาบาลและการยินยอมจากผู้ป่วย: </p>
                  <p style={{marginLeft:40}}>{AllData?.MedicalRecordactionAllowedByHead||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
              </Card>
              <p style={{fontWeight:'bold'}}>ข้อมูลเกี่ยวกับอันตรายหรือความเสี่ยงที่อาจเกิดขึ้นแก่กลุ่มประชากร/กลุ่มตัวอย่าง/ผู้มีส่วนร่วมในการวิจัย รวมทั้งวิธีการป้องกัน/ปกป้องอันตราย และความเสี่ยงนั้น </p>
              <p style={{marginLeft:20}}>{AllData?.RiskAndPrevent||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

              <p style={{fontWeight:'bold'}}>ประโยชน์ในการเข้าร่วมวิจัย: </p>
              <p style={{marginLeft:20}}>{AllData?.Benefit||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>

              <p style={{fontWeight:'bold'}}>การจ่ายค่าพาหนะ ค่าชดเชยการเสียเวลา หรือของที่ระลึก: </p>
              <p style={{marginLeft:20}}>{AllData?.Coverage||<span style={{color:'red'}}>ยังไม่กรอกข้อมูล</span>}</p>
            </Card>
          <br/><hr/>
        <div id="part3"/>
        <h2>ส่วนที่ 3 แนบเอกสารหลักฐานเพิ่มเติม</h2>
        <Table
            rowClassName={() => 'centered-row'}
            columns={[{
                    title:'ลำดับ',
                    width:'2vw',
                    dataIndex:'id',
                    
                },{
                    title:'ประเภทเอกสาร',
                    dataIndex:'AttachmentType',
                    render:(__, record)=> <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center', 
                            height: '100%', 
                        }}
                    >
                        {record.Status === 'แนบแล้ว' ? (
                            <a onClick={() => viewFile(record.AttachmentType)}>{record.AttachmentType}</a>
                        ) : (
                            <p style={{marginTop:0,marginBottom:0}}>{record.AttachmentType}</p>
                        )}
                    
                </div>
                },{
                    title:'สถานะเอกสาร',
                    dataIndex:'Status',
                    render:(__, record)=> <>
                        {record.Status=='แนบแล้ว'&&<p>{record.Status}</p>||
                        <p style={{color:'red'}}>ไม่ได้แนบไฟล์</p>}
                    </>
                }
            ]}
            pagination={false} 
            dataSource={FileAttachment}/>
            <Modal
                open={ShowFile}
                width={'70vw'}
                onCancel={()=>{
                    setShowFile(false);
                    setPreviewUrl(null);
                }}
                footer={<></>}
                >
                    <h2>ข้อมูลเอกสาร</h2>
                    <hr/>
                    {<>{previewUrl ? (
                        <iframe
                            src={previewUrl}
                            width="100%"
                            height="600px"
                            title="PDF Viewer"
                        />
                        ) : (
                        <p>Loading...</p>
                        )}</>}
                                
            </Modal>
            <Modal
                open={ShowMultipleFiles}
                onCancel={()=>{
                    setShowMultipleFiles(false);
                    setPreviewUrl(null);}}
                width={'70vw'}
                footer={<></>}
                >
                <h2>ข้อมูลเอกสาร</h2>
                <hr/>
                <List 
                    pagination={{
                        position: 'bottom',      
                        align: 'end',            
                        pageSize: 5,             
                        showSizeChanger: true,   
                        showQuickJumper: true    
                    }}
                    dataSource={SubFileList}
                    renderItem={(item, index) =>(
                        <><List.Item
                            actions={[<a onClick={()=>ViewTool(item.FileID)}>ดูไฟล์</a> ]}>
                            <List.Item.Meta
                                title={<p>{item.FileName}</p>}
                            />
                        </List.Item>
                            <br/>
                        
                        </>
                    )}
                    />
                    <br/>
                    <Flex justify='center'>
                    {
                        previewUrl&&<>
                            {
                                FileType=='application/pdf'&&
                                <iframe
                                    src={previewUrl}
                                    width="80%"
                                    height="600px"
                                    title="PDF Viewer"
                                    /> ||
                                <img src={previewUrl} alt="Uploaded Image" />
                            }
                        </>
                    }
                    </Flex>
            </Modal>
            <Modal
             width={'70vw'}
            open={ShowImage}
            onCancel={()=>{
                setShowImage(false);
                setPreviewUrl(null);
            }}
            footer={<></>}
            >
                <h2>ข้อมูลเอกสาร</h2>
                <hr/>
                {previewUrl&&<Flex justify='center'>
                    <img src={previewUrl} alt="Uploaded Image" />
                </Flex>}
                <br/>
                <Flex justify='center'>
                    <Button type="primary" icon={<UploadOutlined />} onClick={() => {
                        window.open(previewUrl||'', '_blank');
                        }}>
                        ดาวน์โหลด
                    </Button>&nbsp;</Flex>
            </Modal>
        <hr/>
        <Flex justify='center'><Button>ตีพิมพ์โครงการ</Button></Flex>
        <h2>แบบประเมินสำหรับกรรมการ </h2>
        <p>ประเภทการประเมิน : {AllData?.review_type}</p>
        <Card>
            <p>ชื่อเรื่อง : {AllData?.project_nameTH}({AllData?.project_nameEN})</p>
            <p>ชื่อผู้วิจัย : {AllData?.researcher_THname}</p>
            <br/>
            <h3>การตรวจสอบเกณฑ์โครงการวิจัยที่ยกเว้นการพิจารณาจริยธรรมการวิจัยในมนุษย์ได้</h3>
            <p>โปรดกาเครื่องหมาย √ หน้าหัวข้อที่มีลักษณะตรงกับโครงการวิจัยที่ยกเว้นการพิจารณาจริยธรรมการวิจัยในมนุษย์ได้</p>
            <Form form={Reviewform}>
                <Form.Item name='passedMeasure'>
                    {AllData?.review_type=='การพิจารณาแบบยกเว้น (Exemption)'&&
                    <Checkbox.Group style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8,
                        }}>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด'}
                                >1. เป็นกิจกรรมการเรียนการสอน การประกันคุณภาพการศึกษา การประกันคุณภาพ โรงพยาบาล การปรับปรุงคุณภาพงาน การประเมินผลการให้บริการของหน่วยงาน ทั้งนี้ต้องเป็นการดำเนินการตามแนวทางที่กำหนด</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง'}
                                >2. เป็นการวิจัยโดยใช้วิธีการสำรวจ สัมภาษณ์ ในประชากรที่เป็นผู้ใหญ่สุขภาพดี ทั้งนี้ต้อง</Checkbox>
                                <Checkbox style={{marginLeft:'10vw'}}
                                    value={'2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน'}
                                    >2.1 ไม่มีหัวข้อ คำถามที่อ่อนไหว เช่น พฤติกรรมทางเพศ พฤติกรรมผิดกฎหมาย พฤติกรรมที่เสื่อมเสียชื่อเสียงต่อบุคคล/ชุมชน</Checkbox>
                                <Checkbox style={{marginLeft:'10vw'}}
                                    value={'2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ'}
                                    >2.2 ไม่ถามทัศนคติที่หากเปิดเผยจะเป็นผลเสียแก่การจ้างงาน เช่น การสำรวจความพึง พอใจของข้าราชการเกี่ยวกับสวัสดิการที่ได้รับ</Checkbox>
                                <Checkbox style={{marginLeft:'10vw'}}
                                    value={'2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง'}
                                    >2.3 ผลการสำรวจไม่ทำให้องค์กรที่ให้ข้อมูลเสื่อมเสียชื่อเสียง</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่'}
                                >3. เป็นการวิจัยโดยการสังเกตพฤติกรรมของประชาชนในที่สาธารณะโดยที่</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก'}
                                >3.1 ผู้วิจัยไม่ไปแทรกแซงหรือจัดฉาก</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว'}
                                >3.2 พฤติกรรมที่ถูกสังเกต/สถานที่ที่ใช้สังเกตไม่ล่วงล้ำความเป็นส่วนตัว</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้'}
                                >3.3 ไม่บันทึกข้อมูลในลักษณะที่บ่งบอกถึงตัวบุคคลได้</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)'}
                                >4. เป็นรายงานผู้ป่วย (Case Report) ที่ผู้เสนอขอยกเว้นได้แสดงการปกป้องความลับของผู้ป่วยอย่าง เหมาะสม (หมายเหตุ ผู้วิจัยพึงตระหนักว่าวารสารวิชาการหลายแห่งอาจกำหนดให้มีหลักฐานหนังสือความยินยอมขอใช้ข้อมูลผู้ป่วย หรือภาพผู้ป่วย แล้วแต่กรณี)</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย'}
                                >5. เป็นการวิจัยโดยทดสอบรสชาติอาหาร คุณภาพของอาหาร และความพึงพอใจของผู้บริโภคใน ภาพรวม โดยอาหารที่นำมาทดสอบต้องปลอดภัย และได้มาตรฐานตามข้อกำหนดของสำนักงานคณะกรรมการ อาหารและยา (อย.) ทั้งนี้ ขึ้นอยู่กับดุลยพินิจของประธานฯ หรือผู้ที่ได้รับมอบหมาย</Checkbox>
                    </Checkbox.Group>}
                    {AllData?.review_type=='การพิจารณาแบบเร่งรัด (Expedited Review)'&&
                    <Checkbox.Group style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8,
                        }}>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'1. ส่วนแก้ไขเพิ่มเติมโครงการวิจัยที่เป็นการแก้ไขเพิ่มเติมเล็กน้อยของโครงการวิจัยที่อนุมัติไปแล้วที่เป็นผลให้ความเสี่ยงของผู้ร่วม การวิจัยเพิ่มไม่เกินความเสี่ยงต่ำหรือไม่ทำให้การประเมินความเสี่ยงต่อผลประโยชน์เปลี่ยนไปอย่างมีนัยสำคัญ (Non-significant Risk) เช่น การแก้ไขคำผิด การแก้ไขรูปแบบการเขียนที่ ยังคงความหมายเดิม หรือการเปลี่ยนผู้วิจัยหรือที่อยู่ที่ติดต่อ'}
                                >1. ส่วนแก้ไขเพิ่มเติมโครงการวิจัยที่เป็นการแก้ไขเพิ่มเติมเล็กน้อยของโครงการวิจัยที่อนุมัติไปแล้วที่เป็นผลให้ความเสี่ยงของผู้ร่วม การวิจัยเพิ่มไม่เกินความเสี่ยงต่ำหรือไม่ทำให้การประเมินความเสี่ยงต่อผลประโยชน์เปลี่ยนไปอย่างมีนัยสำคัญ (Non-significant Risk) เช่น การแก้ไขคำผิด การแก้ไขรูปแบบการเขียนที่ ยังคงความหมายเดิม หรือการเปลี่ยนผู้วิจัยหรือที่อยู่ที่ติดต่อ </Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'2. โครงการวิจัยที่มีการสัมภาษณ์ ใช้แบบสอบถามและไม่เป็นข้อมูลลับ หรือข้อมูลที่อ่อนไหว และไม่ก่อผลเสียหายต่อสถานภาพ หรือสิทธิประโยชน์ของบุคคล และไม่ก้าวล่วงความอ่อนไหวของประชากรที่เกี่ยวข้อง'}
                                >2. โครงการวิจัยที่มีการสัมภาษณ์ ใช้แบบสอบถามและไม่เป็นข้อมูลลับ หรือข้อมูลที่อ่อนไหว และไม่ก่อผลเสียหายต่อสถานภาพ หรือสิทธิประโยชน์ของบุคคล และไม่ก้าวล่วงความอ่อนไหวของประชากรที่เกี่ยวข้อง</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'3. การเก็บรวบรวมข้อมูล โดยมีวัตถุประสงค์เพื่อการวิจัยโดยกระบวนการที่ไม่รุกล้ำความเป็นส่วนตัวของบุคคลหรือกลุ่มบุคคล'}
                                >3. การเก็บรวบรวมข้อมูล โดยมีวัตถุประสงค์เพื่อการวิจัยโดยกระบวนการที่ไม่รุกล้ำความเป็นส่วนตัวของบุคคลหรือกลุ่มบุคคล</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'4. การวิจัยเกี่ยวกับการใช้ข้อมูล (Data) บันทึก (Records) เอกสาร (Documents) ที่เก็บรวบรวมไว้แล้วโดยไม่เชื่อมโยงไปถึงตัวบุคคล'}
                                >4. การวิจัยเกี่ยวกับการใช้ข้อมูล (Data) บันทึก (Records) เอกสาร (Documents) ที่เก็บรวบรวมไว้แล้วโดยไม่เชื่อมโยงไปถึงตัวบุคคล</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'5. การวิจัยเกี่ยวกับพฤติกรรมที่เกี่ยวข้องกับลักษณะบุคคล กลุ่มบุคคล หรือการวิจัยที่ใช้วิธีการ สำรวจ สัมภาษณ์ ซักประวัติ การสนทนากลุ่ม (Focus Group) การประเมินโปรแกรมหรือวิธีการเกี่ยวกับการ ประกันคุณภาพ (Quality Assurance)'}
                                >5. การวิจัยเกี่ยวกับพฤติกรรมที่เกี่ยวข้องกับลักษณะบุคคล กลุ่มบุคคล หรือการวิจัยที่ใช้วิธีการ สำรวจ สัมภาษณ์ ซักประวัติ การสนทนากลุ่ม (Focus Group) การประเมินโปรแกรมหรือวิธีการเกี่ยวกับการ ประกันคุณภาพ (Quality Assurance)  </Checkbox>
                    </Checkbox.Group>}
                    {AllData?.review_type=='การพิจารณาแบบเต็มชุด (Full Board Review)'&&
                    <Checkbox.Group style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8,
                        }}>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'1. การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่'}
                                >1. การวิจัยที่เกี่ยวข้องกับประชากรกลุ่มเปราะบาง (Vulnerable Group) ได้แก่</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้'}
                                >1.1 การวิจัยในบุคคลผู้อ่อนด้อยทางฐานะการเงิน หรือการศึกษา หรือผู้อ่านเขียนไม่ได้</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้'}
                                >1.2 การวิจัยในผู้ป่วยที่ไม่สามารถรักษาหายได้</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น'}
                                >1.3 การวิจัยในผู้ป่วยด้วยโรคที่สังคมไม่ยอมรับ เช่น โรคเอดส์ เป็นต้น</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม'}
                                >1.4 การวิจัยในผู้ที่มีความบกพร่องในการตัดสินใจ เช่น ผู้ที่มีความบกพร่องทางจิต ความทรงจำ หรือความผิดปกติด้านพฤติกรรม</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์'}
                                >1.5 การวิจัยในเด็กที่อยู่ในสถานพินิจ/สถานสงเคราะห์</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.6 การวิจัยในกลุ่มผู้สูงอายุที่อยู่ในสถานสงเคราะห์'}
                                >1.6 การวิจัยในกลุ่มผู้สูงอายุที่อยู่ในสถานสงเคราะห์</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.7 การวิจัยในทารกในครรภ์/หญิงตั้งครรภ์'}
                                >1.7 การวิจัยในทารกในครรภ์/หญิงตั้งครรภ์</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.8 การวิจัยในกลุ่มผู้ลี้ภัย'}
                                >1.8 การวิจัยในกลุ่มผู้ลี้ภัย</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.9 การวิจัยในนักโทษหรือผู้ต้องขัง'}
                                >1.9 การวิจัยในนักโทษหรือผู้ต้องขัง</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.10 การวิจัยในกลุ่มคนไร้ที่อยู่'}
                                >1.10 การวิจัยในกลุ่มคนไร้ที่อยู่</Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.11 การวิจัยในชนกลุ่มน้อย หรือผู้ที่ไม่สามารถสื่อสารด้วยภาษาไทยได้'}
                                >1.11 การวิจัยในชนกลุ่มน้อย หรือผู้ที่ไม่สามารถสื่อสารด้วยภาษาไทยได้ </Checkbox>
                            <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.12 การวิจัยในกลุ่มผู้ขายบริการทางเพศ'}
                                >1.12 การวิจัยในกลุ่มผู้ขายบริการทางเพศ</Checkbox>
                                <Checkbox style={{marginLeft:'10vw'}}
                                value={'1.13 การวิจัยในผู้เสพหรือผู้ขายสารเสพติด'}
                                >1.13 การวิจัยในผู้เสพหรือผู้ขายสารเสพติด</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'2. การเปิดเผยตัวของผู้ร่วมการวิจัยก่อให้เกิดความเสี่ยงต่อการรับโทษทางแพ่ง หรือทางอาญา หรือเป็นผลเสียต่อสถานะทางการเงิน การจ้างงาน การประกัน หรืออาชีพ หรือถูกตีตรา เว้นแต่ โครงการวิจัยได้แสดงมาตรการปกป้องการรุกล้ำความเป็นส่วนตัว และความลับไม่ให้รั่วไหลอย่างเหมาะสมจนความเสี่ยงเหลือไม่เกินความเสี่ยงต่ำ'}
                                >2. การเปิดเผยตัวของผู้ร่วมการวิจัยก่อให้เกิดความเสี่ยงต่อการรับโทษทางแพ่ง หรือทางอาญา หรือเป็นผลเสียต่อสถานะทางการเงิน การจ้างงาน การประกัน หรืออาชีพ หรือถูกตีตรา เว้นแต่ โครงการวิจัยได้แสดงมาตรการปกป้องการรุกล้ำความเป็นส่วนตัว และความลับไม่ให้รั่วไหลอย่างเหมาะสมจนความเสี่ยงเหลือไม่เกินความเสี่ยงต่ำ</Checkbox>
                         
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'3. โครงการวิจัยที่ได้รับการพิจารณาให้การรับรองแล้ว และผู้วิจัยต้องการยื่นส่วนแก้ไขเปลี่ยนแปลง (Amendment) ซึ่งส่วนแก้ไขเพิ่มเติมนั้นมีผลกระทบเปลี่ยนแปลงความเสี่ยงของผู้ร่วมการวิจัยที่เพิ่มขึ้นมากกว่าเกณฑ์การประเมินโครงการวิจัยแบบเร่งรัดต้องนำเข้าพิจารณาแบบเต็มชุด'}
                                >3. โครงการวิจัยที่ได้รับการพิจารณาให้การรับรองแล้ว และผู้วิจัยต้องการยื่นส่วนแก้ไขเปลี่ยนแปลง (Amendment) ซึ่งส่วนแก้ไขเพิ่มเติมนั้นมีผลกระทบเปลี่ยนแปลงความเสี่ยงของผู้ร่วมการวิจัยที่เพิ่มขึ้นมากกว่าเกณฑ์การประเมินโครงการวิจัยแบบเร่งรัดต้องนำเข้าพิจารณาแบบเต็มชุด</Checkbox>
                            <Checkbox style={{marginLeft:'5vw'}}
                                value={'4. โครงการวิจัยที่ได้รับการรับรองแล้วและผู้วิจัยต้องการรายงานความก้าวหน้าของโครงการ (Progress Report) แต่มีการดำเนินการที่เบี่ยงเบนไม่ปฏิบัติตามหรือฝ่าฝืนโครงการวิจัยต้องนำเข้า พิจารณาแบบเต็มชุด'}
                                >4. โครงการวิจัยที่ได้รับการรับรองแล้วและผู้วิจัยต้องการรายงานความก้าวหน้าของโครงการ (Progress Report) แต่มีการดำเนินการที่เบี่ยงเบนไม่ปฏิบัติตามหรือฝ่าฝืนโครงการวิจัยต้องนำเข้า พิจารณาแบบเต็มชุด</Checkbox>
                    </Checkbox.Group>}
               </Form.Item>
               <Form.Item>
                <Table
                    columns={[
                        {   
                            title:'ประเด็นพิจารณา',
                            dataIndex:'Topic',
                            width:'30vw'
                        },
                        {
                            title:'ข้อเสนอแนะ',
                            dataIndex:'Reccommendation',
                            render:(__, record,index)=>
                            <>
                                <Form.Item
                                    name={['SumComment', index, 'Reccommendation']}
                                    style={{fontFamily:'Kanit'}}>
                                    <TextArea rows={4} style={{ maxHeight: 120 }} autoSize />
                                </Form.Item>
                            </>
                        },
                    ]}
                    dataSource={ReviewAndRecommendation}/>
               </Form.Item>
               <Form.Item required name='review_result' label='สรุปผลการพิจารณาแบบยกเว้น (Exemption) สำหรับโครงการวิจัยที่เสนอขอรับการรับรองการพิจารณาจริยธรรมการวิจัยในมนุษย์' >
                    <Radio.Group 
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                            }}>
                        <Radio value={'ไม่รับรอง'}>ไม่รับรอง</Radio>
                        <Radio value={'รับรอง'}>รับรอง</Radio>
                        <Radio value={'รับรองในหลักการโดยมีข้อแก้ไข'}> รับรองในหลักการโดยมีข้อแก้ไข</Radio>
                    </Radio.Group>
               </Form.Item>
               {Review_result=='รับรองในหลักการโดยมีข้อแก้ไข'&&
                    <>
                        <Form.Item name='consideration_issues' label='ปริมาณข้อแก้ไขที่นักวิจัยต้องแก้'>
                                <Radio.Group 
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 8,
                                        }}>
                                    <Radio value={'เล็กน้อย'}>เล็กน้อย</Radio>
                                    <Radio value={'ปานกลาง'}>ปานกลาง</Radio>
                                    <Radio value={'มาก'}>มาก</Radio>
                                </Radio.Group>
                        </Form.Item></>}
               <Form.Item label='ข้อเสนอแนะเพิ่มเติม (ถ้ามี)'>
                    <TextArea style={{maxHeight:120}} autoSize/>
               </Form.Item>
                <Flex justify='center'><Button onClick={()=>
                    setComfirmationMod(false)}>ส่งผลพิจารณา</Button></Flex>
            </Form>
            <Modal
                open={ConfirmationMod}
                footer={<></>}>
                    <p>ท่านต้องการจะบันทึกข้อมูลเข้าสู่ระบบหรือไม่ เมื่อกรรมการกดยื่นข้อมูลการพิจารณาครบทุกท่านจะไม่สามารถเปลี่ยนได้อีก</p>
            </Modal>
        </Card>
        </LoadingOverlay>
    </>)
}